import CONST from '../CONST';

function Control({ id, setSelection, utilities }) {
    const {
        state,
        getPromptById,
    } = utilities;
    const {
        title,
        subtitle,
        options,
        control,
    } = getPromptById(id);
    const selection = state.selections[id] || [];
    const toggleSwitch = (e) => {
        e.preventDefault();
        selection.includes(options[0].value)
            ? setSelection([options[1].value])
            : setSelection([options[0].value]);
    };

    switch(control) {
        case CONST.CONTROL_TOGGLE:
            return (
                <fieldset className="switch" onClick={ toggleSwitch }>
                    {
                        options.map(({ text, icon, value }, index) => (
                            <label
                                key={ index }
                                className={ selection.includes(value) ? 'selected' : undefined }
                            >
                                <i className={ 'fa-solid ' + icon }></i>
                                { text }
                            </label>
                        ))
                    }
                </fieldset>
            );

        case CONST.CONTROL_SELECTOR:
            return (
                <fieldset className="select">
                    <h1>{ title }</h1>
                    <h2>{ subtitle }</h2>
                    <ul>
                        { options.map(({ text, value, matcher=()=>true }, index) => (
                            matcher(state) ? (
                                <li
                                    key={ index }
                                    className={ selection.indexOf(value) !== -1 ? 'selected' : undefined }
                                    onClick={
                                        () => setSelection([
                                            value,
                                            ...selection,
                                        ])
                                    }
                                >{ text }</li>
                            ) : undefined
                        )) }
                    </ul>
                </fieldset>
            );

        default:
            return undefined;
    }
};

export default Control;